import VTDancerDisplay from "./VTDancerDisplay";
import {useNavigate} from "react-router-dom";
import React, {useEffect} from "react";
import {clearVenueSession, getLoginSession} from "../../requests/AppSession";
import {ArrowRightStartOnRectangleIcon} from "@heroicons/react/20/solid";

/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
export default function VTStage() {
    let navigate = useNavigate();

    const [userId, setUserId] = React.useState(null);
    const [userName, setUserName] = React.useState("");
    const [userEmail, setUserEmail] = React.useState("");
    const [userRoles, setUserRoles] = React.useState(null);

    useEffect(() => {
        getLoginSession().then(loginSession => {
            if (loginSession && loginSession.userId && loginSession.userId !== "null") {
                setUserId(loginSession.userId);
                setUserName(loginSession.username);
                setUserEmail(loginSession.userEmail);
                setUserRoles(loginSession.roles)
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })
        return function cleanup() {

        };
    }, []);


    return (
        <>
            <div className="bg-pink-600">
                <div className="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8">
                    <div className="flex flex-wrap items-center justify-between">
                        <div className="flex w-0 flex-1 items-center">
                            {userEmail && <p className="hidden truncate text-xs font-normal text-pink-100 sm:block">
                                Signed in as {userEmail}
                            </p>}
                        </div>
                        <div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
                            <a
                                onClick={() => {
                                    navigate('/user/buy');
                                }}
                                className="flex items-center justify-center rounded-md border-0 bg-white px-4 py-2 text-sm font-medium text-pink-600 shadow-sm hover:bg-pink-50"
                            >
                                Buy VirtualTipz
                            </a>
                        </div>
                        {/*<div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">*/}
                        {/*    <button*/}
                        {/*        type="button"*/}
                        {/*        onClick={() => {*/}
                        {/*            clearVenueSession();*/}
                        {/*            navigate('/find');*/}
                        {/*        }}*/}
                        {/*        className="-mr-1 flex rounded-md p-2 hover:bg-pink-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"*/}
                        {/*    >*/}
                        {/*        <span className="sr-only">Dismiss</span>*/}
                        {/*        <ArrowRightStartOnRectangleIcon className="h-6 w-6 text-white" aria-hidden="true"/>*/}
                        {/*    </button>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
            <VTDancerDisplay/>
        </>
    )
}
